import type { ComponentType } from "react";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import type { SvgIconProps } from "@mui/material";
import type { AppRouteKey } from "src/utils/appRoutes/appRoutes";
import {
  AlertCircleIcon,
  ClusterIcon,
  CompareIcon,
  DashboardsIcon,
  DatasetsIcon,
  PipelineIcon,
  PitIcon,
  UsersIcon,
} from "@ui-icons";

/** Icons kept out of Sidebar.constants.ts so node:test can import entry data without SVG loaders. */
export const SIDEBAR_ENTRY_ICONS: Partial<
  Record<AppRouteKey, ComponentType<SvgIconProps>>
> = {
  dashboard: DashboardsIcon,
  apps: PipelineIcon,
  compute: ClusterIcon,
  runs: PitIcon,
  "compare-runs": CompareIcon,
  datasets: DatasetsIcon,
  alerts: AlertCircleIcon,
  users: UsersIcon,
  license: ReceiptLongIcon,
  "super-admin": AdminPanelSettingsIcon,
};
